import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Environment } from "../environment.interface";
import { ENVIRONMENT } from "../environment.token";
import { ILanguage } from "../models/generic/language/language.model";

@Injectable({
    providedIn: 'root'
  })
export class GenericDataService {
    constructor(private httpClient: HttpClient,
        @Inject(ENVIRONMENT) private env: Environment) {
      }
    get(id: string, path: string): Observable<ILanguage> {
        return this.httpClient.get<ILanguage>(`${this.env.apiUrl}/${path}?id=${id}`);
    }
    getAll(path: string): Observable<ILanguage[]> {
        return this.httpClient.get<ILanguage[]>(path).pipe(
        );
    }
    update(mode: ILanguage): Observable<ILanguage> {
        throw new Error("Method not implemented.");
    }
    save(mode: ILanguage): Observable<number> {
        throw new Error("Method not implemented.");
    }
}